// src/config/mentions.config.ts — SCE Issues
// Essai des mentions « @ » (02/11, demande de Guillaume) : tant que
// MENTIONS_EN_ESSAI est vrai, chaque message de mention part au SEUL
// administrateur (ligne de SCE_Envois à son adresse), objet « [Essai] », avec
// en tête qui l'aurait reçu en production et qui en aurait été écarté. On
// voit ainsi le vrai mail et la vraie carte Teams sans déranger personne.
//
// Passer à false pour ouvrir les mentions à tous : chaque personne mentionnée
// reçoit alors son message, selon les règles d'utils/mentions.

import { ADMINS_UPN } from './admin.config'

export const MENTIONS_EN_ESSAI = false

/** Qui reçoit les messages pendant l'essai. */
export const DESTINATAIRE_ESSAI_MENTIONS: string = ADMINS_UPN[0] ?? 'guillaume.delavault1@sartorius.com'
